var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M7.88398 14.1161L12.0001 18.2322L16.1162 14.1161L17.884 15.8839L12.0001 21.7678L6.11621 15.8839L7.88398 14.1161ZM16.1162 9.76777L12.0001 5.65165L7.88398 9.76777L6.11621 8L12.0001 2.11612L17.884 8L16.1162 9.76777Z'
      })
    ),
    props
  );
}

module.exports = Icon;
